import React, { useState } from "react";
import { Comments, commentsData } from "../../../../constant/Data";
import CommentsList from "./CommentsList";
const CommentSection = () => {
  const [likedComments, setLikedComments] = useState(new Set());

  const handleLike = (commentId) => {
    setLikedComments((prev) => {
      const newSet = new Set(prev);
      if (newSet.has(commentId)) {
        newSet.delete(commentId);
      } else {
        newSet.add(commentId);
      }
      return newSet;
    });
  };

  return (
    <div className="min-h-screen bg-white py-4">
      <div className="max-w-3xl mx-auto p-4 border border-[#E5E5E5] rounded-lg">
        <h3 className="text-[#050505] font-bold text-[17px] mb-2">Comments</h3>
        <CommentsList
          comments={commentsData}
          likedComments={likedComments}
          onLike={handleLike}
        />
        <div className="mt-2 text-center text-[#65676B] text-[13px]">
          This post is no longer receiving comments!
        </div>
      </div>
    </div>
  );
};
export default CommentSection;
